import { atom } from "recoil"

// apply form의 정보(Json template 데이터를 저장)
export const eDocApplyFormStateSelector = atom({
	key: "eDocApplyFormStateSelector",
	default: {}
})

// xml template의 정보
export const eDocRequestMetaDataSelector = atom({
	key: "eDocRequestMetaDataSelector",
	default:""
})

// txId - naver 전자서명 트랜젝션 아이디
export const eDocNaverTxIdSelector = atom({
	key:"eDocNaverTxId",
	default:""
})